import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Pipe({
  name: 'invalidChars',
  standalone: true,
  pure: false
})
export class InvalidCharsPipe implements PipeTransform {

  transform(
    formOrControl: FormGroup | AbstractControl | null | undefined,
    pathOrRegex: string | RegExp,
    allowedCharRegex?: RegExp
  ): string {
    let value = '';
    let regex: RegExp;

    if (formOrControl instanceof FormGroup && typeof pathOrRegex === 'string') {
      value = formOrControl.get(pathOrRegex)?.value || '';
      regex = allowedCharRegex!;
    } else {
      value = formOrControl?.value || '';
      regex = pathOrRegex as RegExp;
    }

    if (!value || !regex) return '';

    const invalidChars = [...value].filter(ch => !regex.test(ch));
    return [...new Set(invalidChars)].join(' ');
  }
}